import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Selector from './selector';
import VariableTextField from './variableTextField';

import { MODE } from '../utils/mode';

const VariableSelector = ({
  isVariable,
  mode,
  label,
  name,
  text,
  defaultValue,
  options,
  noLabel,
  ...properties
}) => {
  const [defaultText, setDefaultText] = useState('');
  const [shouldTextUpdate, setShouldTextUpdate] = useState(false);

  useEffect(() => {
    if (options && options.some((option) => option.value === defaultValue)) {
      const foundText = options.find(
        (option) => option.value === defaultValue
      ).text;

      if (foundText) {
        setDefaultText(foundText);
      }
    }
  }, [text, options, defaultValue]);

  useEffect(() => {
    setShouldTextUpdate(true);
  }, [defaultText]);

  useEffect(() => {
    setShouldTextUpdate(false);
  }, [shouldTextUpdate]);

  return !isVariable || mode === MODE.EDIT || mode === MODE.NEW ? (
    <Selector
      name={name}
      placeHolder={label}
      fullWidth
      defaultValue={
        options && options.some((option) => option.value === defaultValue)
          ? defaultValue
          : undefined
      }
      options={options}
      {...properties}
    />
  ) : (
    <>
      {!shouldTextUpdate ? (
        <VariableTextField
          id={name}
          label={label}
          name={name}
          text={text || defaultText}
          mode={mode}
          noLabel={noLabel}
          {...properties}
        />
      ) : undefined}
    </>
  );
};

VariableSelector.propTypes = {
  isVariable: PropTypes.bool,
  mode: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.array,
  noLabel: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

VariableSelector.defaultProps = {
  isVariable: true,
  mode: MODE.VIEW,
  noLabel: false,
};

export default VariableSelector;
